module.exports = __webpack_public_path__ + "img/hb-20.11c248cf.png";